import { commandCenterPricingApi, gsePricingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { GSE_PULL_STATUS, GSE_PULLS_MAX_PAGE_SIZE } from '../marginCenter.constants';
import { mapDeskStatusToView } from '../marginCenter.mappers';

export const DESK_STATUS_ACTION_TYPE = createNamedActions('marginCenter/deskStatus', {
  GET_DESK_STATUS: 'GET_DESK_STATUS',
});

const resolveSettled = result => (result.status === 'fulfilled' ? result.value.data : null);

// Margin Center MC-8 (DEV-4970): the Cockpit's single desk-status view is stitched from THREE Pricing
// endpoints — desk-status (MC-3, per-channel publish state), freshness (MC-4, Base/SRP feed age), and
// quarantine (MC-5, suspect pulls held out of pricing). Each call degrades INDEPENDENTLY
// (Promise.allSettled) so one endpoint being unavailable (403/404/network) never blanks the others — a
// missing piece maps to its honest empty/null value in mapDeskStatusToView, never fabricated data.
export const getDeskStatusAction = catchAsyncActionError(() => async dispatch => {
  const [deskStatusResult, freshnessResult, quarantineResult] = await Promise.allSettled([
    commandCenterPricingApi.getDeskStatus(),
    gsePricingApi.getFreshness(),
    gsePricingApi.getPulls({
      status: GSE_PULL_STATUS.QUARANTINED,
      reviewed: false,
      includeMarketClosed: false,
      pageSize: GSE_PULLS_MAX_PAGE_SIZE,
    }),
  ]);

  const payload = mapDeskStatusToView({
    deskStatus: resolveSettled(deskStatusResult),
    freshness: resolveSettled(freshnessResult) ?? [],
    quarantine: resolveSettled(quarantineResult) ?? [],
    quarantineTotal:
      quarantineResult.status === 'fulfilled' ? quarantineResult.value.totalCount : null,
  });

  return dispatch({ type: DESK_STATUS_ACTION_TYPE.GET_DESK_STATUS, payload });
});
